var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4738 40.492C32.7056 40.492 41.0001 32.1977 41.0001 21.9659C41.0001 11.7341 32.7056 3.43945 22.4738 3.43945C12.2419 3.43945 3.94727 11.7339 3.94727 21.9659C3.94727 32.1978 12.2419 40.492 22.4738 40.492Z",
    fill: "#FFB602"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4688 23.5806C12.4688 38.3155 32.5344 38.3155 32.5344 23.5806H12.4688Z",
    fill: "#EB6D21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.65 14.2137C30.3991 14.2401 31.6034 15.8092 32.1128 17.6913C32.2858 18.3309 31.9077 18.9898 31.2681 19.1629C30.6285 19.336 29.9697 18.9577 29.7964 18.3182C29.3863 16.803 28.7324 16.616 28.6138 16.6141C28.5218 16.6127 27.8691 16.7435 27.439 18.3202C27.2646 18.9595 26.6047 19.3362 25.9654 19.162C25.326 18.9876 24.9482 18.3277 25.1226 17.6883C25.6499 15.7552 26.8744 14.187 28.65 14.2137Z",
    fill: "#B75902"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3707 14.2137C18.1198 14.2401 19.3241 15.8092 19.8335 17.6913C20.0065 18.3309 19.6284 18.9898 18.9888 19.1629C18.3492 19.336 17.6904 18.9577 17.5171 18.3182C17.107 16.8032 16.4533 16.616 16.3345 16.6141C16.2424 16.6127 15.5897 16.7434 15.1597 18.3202C14.9854 18.9595 14.3254 19.3362 13.6861 19.162C13.0467 18.9876 12.6689 18.3277 12.8433 17.6883C13.3706 15.7552 14.5951 14.187 16.3707 14.2137Z",
    fill: "#B75902"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.f8e8cf1c76192bb65c8958edc5e156bb.svg";
export { ForwardRef as ReactComponent };